__turbopack_context__.v({
  "arrow": "ZWV3va_arrow",
  "cardAnchor": "ZWV3va_cardAnchor",
  "cardLink": "ZWV3va_cardLink",
  "container": "ZWV3va_container",
  "dateText": "ZWV3va_dateText",
  "eyebrow": "ZWV3va_eyebrow",
  "foot": "ZWV3va_foot",
  "grid": "ZWV3va_grid",
  "header": "ZWV3va_header",
  "heading": "ZWV3va_heading",
  "pill": "ZWV3va_pill",
  "readLabel": "ZWV3va_readLabel",
  "section": "ZWV3va_section",
  "title": "ZWV3va_title",
  "top": "ZWV3va_top",
});
